// eslint-disable-next-line
import(/* webpackChunkName: 'corteza-base' */ './corteza-base')
